import { Input } from "component/form/input"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { deliveryInfoState } from "state"
import ValidateMessage from "./ValidateMessage"

export default function PhoneNumber() {
  const deliveryInfo = useRecoilValue(deliveryInfoState)
  const setDeliveryInfo = useSetRecoilState(deliveryInfoState)

  const setValidate = (value) => {
    const valueLength = value.length
    setDeliveryInfo({
      ...deliveryInfo,
      phoneNumber: {
        ...deliveryInfo.phoneNumber,
        validate: value
          ? value[0] !== "0" || valueLength < 10 || valueLength > 11
            ? "SĐT bắt đầu từ 0, tối thiểu có 10 và tối đa 11 chữ số."
            : ""
          : "Số điện thoại không được để trống.",
      },
    })
  }

  const handelBlur = (e) => {
    const { value } = e.target
    setValidate(value)
  }

  const handleChange = ({ target }) => {
    if (deliveryInfo.phoneNumber.validate)
      setValidate(target.value)
    setDeliveryInfo({
      ...deliveryInfo,
      phoneNumber: {
        ...deliveryInfo.phoneNumber,
        value: target.value?.length <= 11 ? target.value.trim() : deliveryInfo.phoneNumber.value,
      },
    })
  }

  return (
    <>
      <Input
        className="deliveryInfomation__input"
        placeholder={"Nhập số điện thoại người nhận"}
        value={deliveryInfo.phoneNumber.value}
        onBlur={handelBlur}
        onChange={handleChange}
        validateText={deliveryInfo.phoneNumber.validate}
        validateType={'danger'}
        validateClass={'hidden'}
        type={'number'}
        maxLength={11}
      />
      <ValidateMessage>{deliveryInfo.phoneNumber.validate}</ValidateMessage>
    </>
  )
}
